<template>
    <el-menu-item
        v-if="menu.resourceType === 2 && menu.extendAttr1 !== 'lcp-hidden'"
        :class="route.path === menu.frontUrl ? 'isSub' : ''"
        :data-level="level"
        :index="routerPath(menu.frontUrl)"
        @click="goToLink(menu.frontUrl)"
    >
        <em
            :class="
                menu.resourceUrl && menu.resourceUrl.indexOf('icon-') > -1
                    ? `iconfont ${menu.resourceUrl} menuIcon`
                    : ''
            "
        ></em>
        <template #title>
            <span
                :class="isSubMenu ? 'heighLight6' : 'heighLight8'"
                :title="
                    $translate(`lang.${menu.resourceCode}`, {
                        defaultText: menu.resourceName
                    })
                "
            >
                {{
                    $translate(`lang.${menu.resourceCode}`, {
                        defaultText: menu.resourceName
                    })
                }}
            </span>
        </template>
    </el-menu-item>
    <el-submenu v-if="menu.resourceType !== 2" :index="menu.resourceCode" :data-level="level">
        <template #title>
            <em
                :class="
                    menu.resourceUrl && menu.resourceUrl.indexOf('icon-') > -1
                        ? `iconfont ${menu.resourceUrl} customIcon`
                        : 'iconfont icon-gather customIcon'
                "
            ></em>
            <span
                :class="isSubMenu ? 'heighLight6' : 'heighLight8'"
                :title="
                    $translate(`lang.${menu.resourceCode}`, {
                        defaultText: menu.resourceName
                    })
                "
            >
                {{
                    $translate(`lang.${menu.resourceCode}`, {
                        defaultText: menu.resourceName
                    })
                }}
            </span>
        </template>
        <menu-item
            v-for="(subMenu, index) in menu.subResources.filter(
                k => k.extendAttr1 !== 'lcp-hidden'
            )"
            :menu="subMenu"
            :level="level + 1"
            :key="index + subMenu.resourceCode"
            isSubMenu
        >
        </menu-item>
        <!-- <menu-item
            v-for="(subMenu, index) in menu.subResources"
            :key="index + subMenu.resourceCode"
            isSubMenu
        >
        </menu-item> -->
    </el-submenu>
</template>

<script>
import { defineComponent } from 'vue';
import { useRoute } from 'vue-router';
import { I18nMixins } from '@/utils/i18n';

export default defineComponent({
    name: 'MenuItem',
    mixins: [I18nMixins],
    props: {
        menu: {
            type: Object,
            default() {
                return {};
            }
        },
        level: {
            type: Number,
            default() {
                return 0;
            }
        },
        collapse: {
            default() {
                return false;
            }
        },
        isSubMenu: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const route = useRoute();

        // methods
        const goToLink = url => {
            if (url.indexOf('http') === 0) {
                window.open(url);
            }
        };
        const routerPath = url => {
            return url.indexOf('http') === 0 ? '' : url;
        };

        return {
            route,
            routerPath,
            goToLink
        };
    }
});
</script>

<style lang="less">
.side-bar-menu {
    [data-level="1"] {
        &.el-menu-item {
            padding-left: 46px!important;
        }
    }
}
</style>
